import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgAlignLeft01 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 3v18m18-9H7m0 0 7 7m-7-7 7-7"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgAlignLeft01)
export default ForwardRef
